import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Heading_banner_section from "../../../common_components/heading_banner/Heading_banner_section";
import { faArrowRight, faShoppingBag } from "@fortawesome/free-solid-svg-icons";
import Purple_Btn from "../../../common_components/common_btn/purple_btn/Purple_Btn";
import Success_modal from "../../../common_components/success_modal/Success_modal";
import { Controller, useForm } from "react-hook-form";
import { RegxExpression } from "../../../../utils/common";
import classNames from "classnames";
import { ProductQuery } from "../../../../utils/luxuryapis/form/form";
function Form_component() {
  const [modalShow, setModalShow] = React.useState(false);
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "PRODUCT CARE" },
  ];

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("product_code", data?.product_code);
    formData.append("product_query", data?.product_query);
    formData.append("agree_status", data?.agree_status);
    formData.append("name", data?.name);
    formData.append("email", data?.email);
    formData.append("contact_no", data?.contact_no);

    const res = await ProductQuery(formData);
    if (res?.success) {
      reset();
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
      }, 3000);
    } else {
    }
  };
  return (
    <>
      <section className="Form_component">
        <Heading_banner_section
          headingText={"PRODUCT CARE"}
          subHeadingText={"Care. Love. Preserve. Shine."}
          breadcrumbItems={breadcrumbItems}
        />
        <div className="form_section_holder">
          <div className="custom_container">
            <div className="row justify-content-center">
              <div className="col-md-8 order-1 order-2">
                <div className="content_box_holder">
                  <div className="form_holder">
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      <Form.Group className="mb-3">
                        <Form.Label>Enter Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Enter Name"
                          {...register("name", {
                            required: "Name is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.name,
                            "is-valid": getValues("name"),
                          })}
                          onKeyDown={(event) => {
                            if (!RegxExpression.name.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        {errors?.name && (
                          <sup className="text-danger mt-3">
                            {errors?.name?.message}
                          </sup>
                        )}
                      </Form.Group>

                      {/* Email */}
                      <Form.Group className="mb-3">
                        <Form.Label>Enter Email Address*</Form.Label>
                        <Form.Control
                          type="text"
                          name="email"
                          placeholder="Enter Email Address"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: RegxExpression.email,
                              message: "Invalid email address",
                            },
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.email,
                            "is-valid": getValues("email"),
                          })}
                        />
                        {errors?.email && (
                          <sup className="text-danger mt-3">
                            {errors?.email?.message}
                          </sup>
                        )}
                      </Form.Group>

                      {/* Phone */}
                      <Form.Group className="mb-3">
                        <Form.Label>Contact*</Form.Label>
                        <Controller
                          name="contact_no"
                          control={control}
                          rules={{
                            required: "Field is required",
                            pattern: {
                              value: /^\+?\d{1,4}[-\s]?\d{10}$/,
                              message:
                                "Invalid number format. Please enter a valid number with an optional country code",
                            },
                          }}
                          render={({ field }) => (
                            <PhoneInput
                              country={"in"}
                              {...field}
                              className={classNames("", {
                                "is-invalid": errors?.contact_no,
                                "is-valid": getValues("contact_no"),
                              })}
                              onChange={(value) => field.onChange(value)}
                              type="text"
                              placeholder="Enter Mobile Number"
                              onKeyDown={(event) => {
                                if (!RegxExpression.phone.test(event.key)) {
                                  if (event.key !== "Backspace") {
                                    event.preventDefault();
                                  }
                                }
                              }}
                              maxLength={10}
                            />
                          )}
                        />
                        {errors?.contact_no && (
                          <sup className="text-danger mt-3">
                            {errors?.contact_no?.message}
                          </sup>
                        )}
                      </Form.Group>

                      {/* Enter Product Name Or Code */}
                      <Form.Group className="mb-4">
                        <Form.Label>Enter Product Name Or Code</Form.Label>

                        <Form.Control
                          type="text"
                          name="message"
                          placeholder="Enter Product Name Or Code"
                          {...register("product_code", {
                            required: "Product Code is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.product_code,
                            "is-valid": getValues("product_code"),
                          })}
                        />

                        {errors?.product_code && (
                          <sup className="text-danger">
                            {errors?.product_code?.message}
                          </sup>
                        )}
                      </Form.Group>

                      {/* Message */}
                      <Form.Group className="mb-4">
                        <Form.Label>
                          Type a Query regarding your product
                        </Form.Label>
                        {/* <Form.Control
                          as="textarea"
                          rows={4}
                          placeholder="Type a Query regarding your product..."
                        /> */}

                        <Form.Control
                          as="textarea"
                          rows={4}
                          name="product_query"
                          placeholder="Product Query"
                          {...register("product_query", {
                            required: "Product Query is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.product_query,
                            "is-valid": getValues("product_query"),
                          })}
                        />

                        {errors?.product_query && (
                          <sup className="text-danger">
                            {errors?.product_query?.message}
                          </sup>
                        )}
                      </Form.Group>

                      {/* Button */}
                      <div className="btn_holder">
                        <Purple_Btn
                          btnText={"Send Request"}
                          rightIcon={faArrowRight}
                          type="submit"
                          // onClick={() => setModalShow(true)}
                        />
                      </div>
                    </Form>
                  </div>
                </div>
              </div>

              {/* Right Image */}
              <div className="col-md-4 col-sm-6 order-md-2 order-sm-1 order-1">
                <div className="img_holder">
                  <img
                    src="/assest/luxury_images/support/peronal_care/form_img/personal care.png"
                    alt="help"
                    className="supprt_img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Success_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText={"PRODUCT QUERY SEND SUCCESSFULLY!"}
      />
    </>
  );
}

export default Form_component;
